function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import * as React from "react";
import * as ProfileApi from "../ajax/ProfileApi";
import IntlMessage from '../commons/Intl';
import { Label, Errors, Action, Password } from '../commons/IntlMessages';
import { ApiResultCodes } from "../enum/ApiResultCodes";
var defaultLanguage = 'ja';
var intl = new IntlMessage(defaultLanguage);
var language = window.navigator.language.substring(0, 2) === 'ja' ? 'ja' : 'en';
intl.setLanguage(language); // ユーザーパスワード変更モーダル

/**
 * モード
 */

export var Mode;

(function (Mode) {
  /**
   * なし
   */
  Mode[Mode["None"] = 0] = "None";
  /**
   * 更新
   */

  Mode[Mode["Modify"] = 2] = "Modify";
})(Mode || (Mode = {}));
/**
 * メインコンポーネント
 */


var MainComponent = /*#__PURE__*/function (_React$Component) {
  _inherits(MainComponent, _React$Component);

  var _super = _createSuper(MainComponent);

  /**
   * フィールド変数の初期化を行います。
   *
   * @param props プロップス
   */
  function MainComponent(props) {
    var _this;

    _classCallCheck(this, MainComponent);

    _this = _super.call(this, props);

    switch (props.mode) {
      case Mode.Modify:
        _this.state = {
          Modal: null,
          UserId: _this.props.userId,
          CurrentPassword: "",
          Password: "",
          PasswordRe: "",
          ErrorMessages: []
        };
        break;

      default:
        throw Error();
    }

    _this.GetThumbnailUrl();

    return _this;
  }

  _createClass(MainComponent, [{
    key: "GetThumbnailUrl",
    value: function GetThumbnailUrl() {
      if (!this.props.userId || !this.props.thumbnailFileName) {
        return;
      }

      ProfileApi.GetThumbnail(this.state.UserId, this.props.thumbnailFileName, function (blob) {
        $("#userthumbnailmodaliconframe").css("background-image", 'url(' + window.URL.createObjectURL(blob) + ')');
        var thumbnailFrame = $("#thumbnailframe");
        thumbnailFrame.css("background-image", 'none');
      });
    }
    /**
     * 現在のパスワードを更新します。
     *
     * @param e イベント
     */

  }, {
    key: "updateCurrentPassword",
    value: function updateCurrentPassword(e) {
      this.setState({
        CurrentPassword: e.target.value.substring(0, e.target.maxLength)
      });
    }
    /**
     * 新しいパスワードを更新します。
     *
     * @param e イベント
     */

  }, {
    key: "updatePassword",
    value: function updatePassword(e) {
      this.setState({
        Password: e.target.value.substring(0, e.target.maxLength)
      });
    }
    /**
     * 新しいパスワード（再入力）を更新します。
     *
     * @param e イベント
     */

  }, {
    key: "updatePasswordRe",
    value: function updatePasswordRe(e) {
      this.setState({
        PasswordRe: e.target.value.substring(0, e.target.maxLength)
      });
    }
    /**
     * 「更新」ボタン押下時の処理を行います。
     */

  }, {
    key: "onModify",
    value: function onModify() {
      var _this2 = this;

      if (this.state.Modal == null || !this.props.userId) {
        throw Error();
      }

      var form = $("#MainForm");
      $.validator.unobtrusive.parse(form);
      form.validate();

      if (form.valid()) {
        if (!this.props.userId) {
          throw Error();
        }

        this.state.ErrorMessages.length = 0;

        if (this.state.Password != this.state.PasswordRe) {
          this.state.ErrorMessages.push(intl.format(Errors.DataNotMatch, {
            title: intl.format(Label.Password)
          }));
        }

        if (this.state.ErrorMessages.length != 0) {
          this.setState({
            ErrorMessages: this.state.ErrorMessages
          });
          return;
        }

        this.props.onModify(this.props.userId, this.state.CurrentPassword, this.state.Password, this.props.updateDateTime, function (result) {
          if (result.ResultCode == ApiResultCodes.Success) {
            if (_this2.state.Modal != null) _this2.state.Modal.modal('hide');
          }
        });
      }
    }
    /**
     * ComponentがDOMツリーに追加された状態で呼ばれるDOMに関わる初期化処理
     */

  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this3 = this;

      var modal = $('#UserModal');
      this.setState({
        Modal: modal
      });
      modal.modal({
        backdrop: 'static',
        keyboard: false
      }); // ポップアップが完全に非表示になった時のイベント。

      modal.on("hidden.bs.modal", function () {
        _this3.props.onHidden();
      });
      $("form").removeData("validator").removeData("unobtrusiveValidation").off("submit.validate click.validate focusin.validate focusout.validate keyup.validate invalid-form.validate");
      $.validator.unobtrusive.parse("form");
    }
    /**
     * レンダラー
     */

  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      return /*#__PURE__*/React.createElement("div", {
        className: "modal fade",
        id: "UserModal",
        role: "dialog"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-dialog modal-lg",
        role: "document"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-content"
      }, this.state.ErrorMessages.length > 0 && /*#__PURE__*/React.createElement("div", {
        className: "validation-summary-errors alert alert-danger"
      }, /*#__PURE__*/React.createElement("ul", null, this.state.ErrorMessages.map(function (x, i) {
        return /*#__PURE__*/React.createElement("li", {
          key: i
        }, x);
      }))), /*#__PURE__*/React.createElement("div", {
        className: "modal-header"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-title"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modalIcon"
      }, /*#__PURE__*/React.createElement("div", {
        id: "userthumbnailmodaliconframe",
        className: "thumbnailicon40frame"
      })), /*#__PURE__*/React.createElement("h3", null, intl.format(Password.Title))), /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "modal-close",
        "data-dismiss": "modal",
        "aria-label": "Close",
        tabIndex: -1
      }, /*#__PURE__*/React.createElement("span", {
        "aria-hidden": "true"
      }, "\xD7"))), /*#__PURE__*/React.createElement("div", {
        className: "modal-body"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-9 mx-auto"
      }, /*#__PURE__*/React.createElement("div", {
        className: "form-group row"
      }, /*#__PURE__*/React.createElement("label", {
        className: "col-4 col-form-label",
        htmlFor: "CurrentPassword"
      }, intl.format(Label.CurrentPassword)), /*#__PURE__*/React.createElement("div", {
        className: "col-8"
      }, /*#__PURE__*/React.createElement("input", {
        type: "password",
        className: "form-control",
        name: "CurrentPassword",
        id: "CurrentPassword",
        "data-val": "true",
        "data-val-nowhitespace": intl.format(Errors.InputRequired),
        maxLength: 128,
        onChange: function onChange(e) {
          return _this4.updateCurrentPassword(e);
        },
        value: this.state.CurrentPassword,
        tabIndex: 101
      }), /*#__PURE__*/React.createElement("span", {
        className: "text-danger",
        "data-valmsg-for": "CurrentPassword",
        "data-valmsg-replace": "true",
        style: {
          fontSize: "16px"
        }
      }))), /*#__PURE__*/React.createElement("div", {
        className: "form-group row"
      }, /*#__PURE__*/React.createElement("label", {
        className: "col-4 col-form-label",
        htmlFor: "Password"
      }, intl.format(Label.Password)), /*#__PURE__*/React.createElement("div", {
        className: "col-8"
      }, /*#__PURE__*/React.createElement("input", {
        type: "password",
        className: "form-control",
        name: "Password",
        id: "Password",
        "data-val": "true",
        "data-val-nowhitespace": intl.format(Errors.InputRequired),
        maxLength: 128,
        onChange: function onChange(e) {
          return _this4.updatePassword(e);
        },
        value: this.state.Password,
        tabIndex: 102
      }), /*#__PURE__*/React.createElement("span", {
        className: "text-danger",
        "data-valmsg-for": "Password",
        "data-valmsg-replace": "true",
        style: {
          fontSize: "16px"
        }
      }))), /*#__PURE__*/React.createElement("div", {
        className: "form-group row"
      }, /*#__PURE__*/React.createElement("label", {
        className: "col-4 col-form-label",
        htmlFor: "PasswordRe"
      }, intl.format(Label.RePassword)), /*#__PURE__*/React.createElement("div", {
        className: "col-8"
      }, /*#__PURE__*/React.createElement("input", {
        type: "password",
        className: "form-control",
        name: "PasswordRe",
        id: "PasswordRe",
        "data-val": "true",
        maxLength: 128,
        onChange: function onChange(e) {
          return _this4.updatePasswordRe(e);
        },
        value: this.state.PasswordRe,
        tabIndex: 103
      }), /*#__PURE__*/React.createElement("span", {
        className: "text-danger",
        "data-valmsg-for": "PasswordRe",
        "data-valmsg-replace": "true",
        style: {
          fontSize: "16px"
        }
      }))))), /*#__PURE__*/React.createElement("div", {
        className: "modal-footer justify-content-center"
      }, /*#__PURE__*/React.createElement("button", {
        key: "onModify",
        type: "button",
        className: "btn btn-primary",
        onClick: this.onModify.bind(this),
        tabIndex: 104
      }, intl.format(Action.Entry))))));
    }
  }]);

  return MainComponent;
}(React.Component);

export { MainComponent as default };